import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=2a75eac6&scoped=true&lang=html&"
import script from "./Comment.vue?vue&type=script&lang=coffee&"
export * from "./Comment.vue?vue&type=script&lang=coffee&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=2a75eac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a75eac6",
  null
  
)

component.options.__file = "Comment.vue"
export default component.exports